import Head from 'next/head'
import config from '../config'

export interface MetaTagsProps {
  pageTitle: string
  pageRelativeURL?: string
  description?: string
  imageURL?: string
  imageAltText?: string
}

export default function MetaTags({
  pageTitle,
  pageRelativeURL,
  description,
  imageURL = `${config.siteUrl}/pow_uk_meta_1200x628.png`,
  imageAltText = 'POW UK logo overlayed on an image of hills and trees',
}: MetaTagsProps) {
  return (
    <Head>
      {/* <!-- Primary Meta Tags --> */}
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle} />
      {!!description && <meta name="description" content={description} />}

      {/* <!-- Open Graph / Facebook --> */}
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={
          pageRelativeURL
            ? `${config.siteUrl}${pageRelativeURL}`
            : `${config.siteUrl}`
        }
      />
      <meta property="og:title" content={pageTitle} />
      {!!description && <meta name="og:description" content={description} />}
      <meta property="og:image" content={imageURL} />
      <meta property="og:image:alt" content={imageAltText} />

      {/* <!-- Twitter --> */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:url"
        content={
          pageRelativeURL
            ? `${config.siteUrl}${pageRelativeURL}`
            : `${config.siteUrl}`
        }
      />
      <meta name="twitter:title" content={pageTitle} />
      {!!description && (
        <meta name="twitter:description" content={description} />
      )}
      <meta name="twitter:image" content={imageURL} />
      <meta name="twitter:image:alt" content={imageAltText} />
    </Head>
  )
}
